import { forwardRef } from "react";

import Icon from "@/components/Icon";
import ClassLinkSVG from "./ClasslinkSVG.svg.jsx";

const ClassLinkIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={ClassLinkSVG} {...props} />;
});

export default ClassLinkIcon;
